import React, { useEffect, useState } from "react";
import { Container, Typography, Grid, AppBar, Grow } from "@material-ui/core";
import Posts from "../Posts/Posts";
import { useDispatch, useSelector } from "react-redux";
import Form from "../Form/Form";
import useStyles from "./styles";
import { getPosts } from "../../actions/posts";
import { BrowserRouter, Switch, Route } from "react-router-dom";
const Home = () => {
  const [currentId, setCurrentId] = useState(null);
  const styles = useStyles();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPosts());
  }, [dispatch]);
  return (
    <Grow in>
      <Container>
        <Grid
          container
          justify="space-between"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12} sm={7}>
            <Posts currentId={currentId} setCurrentId={setCurrentId} />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Form currentId={currentId} setCurrentId={setCurrentId} />
          </Grid>
        </Grid>
      </Container>
    </Grow>
  );
};

export default Home;
